<template>
  <div v-if="mybidLoading" class="mybind-detail-container">
    <el-form>
      <!--竞价文件 -->
      <bidFile :form="form" :is-edit="isEdit" :is-display="isDisplay" :template-data-source="templateDataSource" :goods-type-option="goodsTypeOption" />
      <!--竞价规则 -->
      <bidRule :form="form" :is-edit="isEdit" :is-display="isDisplay" />
      <!--其他设置 -->
      <bidOther :form="form" :is-edit="isEdit" :is-display="isDisplay" />
      <!--竞价须知 -->
      <bidNotice :form="form" :is-edit="isEdit" :is-display="isDisplay" />
      <!--联系方式 -->
      <bidContact :form="form" :is-edit="isEdit" :is-display="isDisplay" />
    </el-form>
  </div>
</template>

<script>
import bidOther from '../components/bidOther'
import bidRule from '../components/bidRule'
import bidFile from '../components/bidFile'
import bidNotice from '../components/bidNotice'
import bidContact from '../components/bidContact'
import http from '@/plugin/axios'
export default {
  components: {
    bidRule,
    bidOther,
    bidFile,
    bidNotice,
    bidContact
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        biddingNo: '',
        biddingName: '',
        planSignDate: '',
        projectBudget: '',
        biddingRounds: 3,
        roundsList: [
          {
            keys: 1,
            biddingStartTime: '',
            biddingEndTime: '',
            hidePriceSign: ''
          },
          {
            keys: 2,
            biddingStartTime: '',
            biddingEndTime: '',
            hidePriceSign: ''
          },
          {
            keys: 3,
            biddingStartTime: '',
            biddingEndTime: '',
            hidePriceSign: 'Y'
          }
        ],
        goodsList: [],
        fileList: [],
        // 竞价规则
        inviteSupplierList: [],
        roundLength: 10,
        revesion: 0,
        // 其他设置
        quoteRequirementsSign: '',
        uploadFileSign: '',
        mailBiddingSign: '',
        qualificationSign: '',
        requiredQualificationName: '',
        mailReceiver: '',
        mailPhone: '',
        mailDate: '',
        mailAddress: '',
        // 竞价通知
        biddingNotice: '',
        // 联系方式
        purOfficeNo: '',
        email: '',
        phone: '',
        operator: '',
        status: '' // 单价状态
      },
      templateDataSource:
        {
          goodsType: '',
          key: 0,
          number: '',
          name: '',
          model: '',
          category: '',
          technologyName: '',
          unit: '',
          currencyNo: '',
          qty: '',
          fixedPrice: '',
          purchaseStandard: '',
          expectedDeliveryDate: '',
          goodsFileList: []

        }, // 数据源
      goodsTypeOption: [
        {
          label: '物资',
          value: '1'
        },
        {
          label: '工艺',
          value: '2'
        }
      ],
      isEdit: false,
      isDisplay: true,
      mybidLoading: false
    }
  },
  async created() {
    if (this.data.id) {
      await this.getInfo(this.data.id)
      this.mybidLoading = true
      return
    }
  },
  methods: {
    // 编辑
    async getInfo(id) {
      const info = await http({
        url: '/srmBiddingHead/getBiddingDetail',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: {
          id
        }
      })
      this.form = { ...this.form, ...info }
    }
  }
}
</script>
<style lang="scss" scoped>
.mybind-detail-container{
   width: 100%;
   color: #333;
}
</style>

